import { defineMessages } from 'react-intl';

export default defineMessages({
	unknownField: {
		defaultMessage: 'Unknown field: {id}',
		description: 'Fallback message to display field when its type is unknown',
		id: 'cv.request.create.form.field.unknown',
	},
});
